import { AGENT_API } from '../AgentAPI';
export function createNotificationService(api) {
    return {
        getBannerNotification() {
            return api.fetch(AGENT_API.GET_BANNER_NOTIFICATIONS);
        },
        getBannerNotificationLink(id) {
            return api.fetch(AGENT_API.GET_BANNER_NOTIFICATION_LINK, { config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=NotificationService.js.map